import React from "react";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import * as THREE from "three";
import { OBJLoader } from "three/addons/loaders/OBJLoader.js";
import { GLTFLoader } from "three/addons/loaders/GLTFLoader.js";
import { EffectComposer } from "three/addons/postprocessing/EffectComposer.js";
import { RenderPass } from "three/addons/postprocessing/RenderPass.js";
import { UnrealBloomPass } from "three/addons/postprocessing/UnrealBloomPass.js";
import { OutputPass } from "three/addons/postprocessing/OutputPass.js";
import { ShaderPass } from "three/addons/postprocessing/ShaderPass.js";
import { EXRLoader } from "three/addons/loaders/EXRLoader.js";
import { useNavigate } from "react-router-dom";
import { isMobile } from "detect-touch-device";
import Partners from "./Partners";
import ModalVideo from "./ModalVideo.js";
import WorkModal from "./WorkModal.js";
import Contact from "./Contact.js";
import PixelateHover from "./PixelateHover.js";

const S3 = "https://digitalgardenmx.s3.us-east-1.amazonaws.com";

const aboutPlaceholder = `${S3}/common/about-placeholder.png`;
const logo = `${S3}/common/logo-dg.svg`;
const logow = `${S3}/common/logo-dg-white.svg`;
const playBtn = `${S3}/common/play-btn.png`;
const quote = `${S3}/common/quote.svg`;
const wWork2 = `${S3}/common/work2.jpg`;
const wComoDesktop = `${S3}/common/como-desktop.jpg`;

// Logos
const logoAeromex = `${S3}/logos/aeromexico.png`;
const logoCocacola = `${S3}/logos/cocacola.png`;
const logoComex = `${S3}/logos/comex.png`;
const logoSpotify = `${S3}/logos/spotify.png`;
const logoDuolingo = `${S3}/logos/duolingo.png`;
const logoTrevor = `${S3}/logos/trevor.png`;
const logoLenovo = `${S3}/logos/lenovo.png`;
const logoChilango = `${S3}/logos/chilango.png`;
const logoVictoria = `${S3}/logos/victoria.png`;
const logoMercedes = `${S3}/logos/mercedes.png`;
const logoNescafe = `${S3}/logos/nescafe.png`;
const logoColgate = `${S3}/logos/colgate.png`;
const logoMilOcho = `${S3}/logos/1800.png`;
const logoHolcim = `${S3}/logos/holcim.png`;
const logoChevrolet = `${S3}/logos/chevrolet.png`;

// Work - Artika
const artika01 = `${S3}/work/artika/01.jpg`;
const artika02 = `${S3}/work/artika/02.jpg`;
const artika03 = `${S3}/work/artika/03.jpg`;
const artika04 = `${S3}/work/artika/04.jpg`;
const artika05 = `${S3}/work/artika/05.jpg`;
const artika06 = `${S3}/work/artika/06.jpg`;
const artika07 = `${S3}/work/artika/07.jpg`;
const artika08 = `${S3}/work/artika/08.jpg`;

// Grid Images
const uno = `${S3}/work/uno.png`;
const dos = `${S3}/work/dos.png`;
const tres = `${S3}/work/tres.png`;
const cuatro = `${S3}/work/cuatro.png`;
const cinco = `${S3}/work/cinco.png`;
const seis = `${S3}/work/seis.png`;
const siete = `${S3}/work/siete.jpg`;
const ocho = `${S3}/work/ocho.png`;
const nueve = `${S3}/work/nueve.png`;
const catorce = `${S3}/work/catorce.png`;
const dieciseis = `${S3}/work/dieciseis.png`;
const dieciocho = `${S3}/work/1800.png`;
const mezcalbuenviaje = `${S3}/work/mezcalbuenviaje.png`;
const holcim = `${S3}/work/holcim.png`;
const shopify = `${S3}/work/shopify.png`;

// Work - Mercedes
const mercedes01 = `${S3}/work/mercedes/01.png`;
const mercedes02 = `${S3}/work/mercedes/02.png`;
const mercedes03 = `${S3}/work/mercedes/03.png`;
const mercedes04 = `${S3}/work/mercedes/04.png`;
const mercedes05 = `${S3}/work/mercedes/05.png`;
const mercedes06 = `${S3}/work/mercedes/06.png`;
const mercedes07 = `${S3}/work/mercedes/07.png`;
const mercedes08 = `${S3}/work/mercedes/08.png`;
const mercedes09 = `${S3}/work/mercedes/09.png`;
const mercedes10 = `${S3}/work/mercedes/10.png`;

// Work - Yim
const yim01 = `${S3}/work/yim/01.png`;
const yim02 = `${S3}/work/yim/02.png`;
const yim03 = `${S3}/work/yim/03.png`;
const yim04 = `${S3}/work/yim/04.png`;
const yim05 = `${S3}/work/yim/05.png`;

// Work - Nike
const posterNike = `${S3}/work/nike-poster.jpg`;
const posterDoritos = `${S3}/work/doritos/poster.jpg`;

// Work - Palacio de Hierro
const palacio01 = `${S3}/work/palacio/01.jpg`;
const palacio02 = `${S3}/work/palacio/02.jpg`;
const palacio03 = `${S3}/work/palacio/03.jpg`;
const palacio04 = `${S3}/work/palacio/04.jpg`;
const palacio05 = `${S3}/work/palacio/05.jpg`;
const palacio06 = `${S3}/work/palacio/06.jpg`;
const palacio07 = `${S3}/work/palacio/07.jpg`;
const palacio08 = `${S3}/work/palacio/08.jpg`;
const palacio09 = `${S3}/work/palacio/09.jpg`;
const palacio10 = `${S3}/work/palacio/10.jpg`;

// Work - Fud
const fud01 = `${S3}/work/fud/01.jpg`;
const fud02 = `${S3}/work/fud/02.jpg`;
const fud03 = `${S3}/work/fud/03.jpg`;
const fud04 = `${S3}/work/fud/04.jpg`;
const fud05 = `${S3}/work/fud/05.jpg`;
const fud06 = `${S3}/work/fud/06.jpg`;

// Work - Chevrolet
const chevrolet01 = `${S3}/work/chevrolet/asesor.jpg`;

// Work - 1800
const milocho01 = `${S3}/work/1800/01.jpg`;
const milocho02 = `${S3}/work/1800/02.jpg`;
const milocho03 = `${S3}/work/1800/03.jpg`;
const milocho04 = `${S3}/work/1800/04.jpg`;
const milocho05 = `${S3}/work/1800/05.jpg`;
const milocho06 = `${S3}/work/1800/06.jpg`;
const milocho07 = `${S3}/work/1800/07.jpg`;
const milocho08 = `${S3}/work/1800/08.jpg`;
const milocho09 = `${S3}/work/1800/09.jpg`;
const milocho10 = `${S3}/work/1800/10.jpg`;
const milocho11 = `${S3}/work/1800/11.jpg`;
const milocho12 = `${S3}/work/1800/12.jpg`;

// Work - 3d
const tresd01 = `${S3}/work/tresd/Ches-Pose-01_Entrega.jpg`;
const posterChonchito = `${S3}/work/chonchito-poster.jpg`;
const tresd02 = `${S3}/work/tresd/CurlyLATAM.jpg`;
const tresd03 = `${S3}/work/tresd/FINK-pose-01.jpg`;
const tresd04 = `${S3}/work/tresd/render06.jpg`;

// Work - Colgate
const posterColgate = `${S3}/work/colgate/posterColgate.png`;

// Work - eCommerce
const ecommerce01 = `${S3}/work/ecommerce/01.png`;
const ecommerce02 = `${S3}/work/ecommerce/02.png`;

// Work - Mobil
const mobil01 = `${S3}/work/mobil/Movil_01.jpg`;
const mobil02 = `${S3}/work/mobil/Movil_02.jpg`;
const mobil03 = `${S3}/work/mobil/Movil_03.jpg`;
const mobil04 = `${S3}/work/mobil/Movil_04.jpg`;
const mobil05 = `${S3}/work/mobil/Movil_05.jpg`;
const mobil06 = `${S3}/work/mobil/Movil_06.jpg`;
const mobil07 = `${S3}/work/mobil/Movil_07.jpg`;

// Work - Plug & Plant
const plug01 = `${S3}/work/plug/01.jpg`;
const plug02 = `${S3}/work/plug/02.jpg`;
const plug03 = `${S3}/work/plug/03.jpg`;
const plug04 = `${S3}/work/plug/04.jpg`;
const plug05 = `${S3}/work/plug/05.jpg`;
const plug06 = `${S3}/work/plug/06.jpg`;
const plug07 = `${S3}/work/plug/07.jpg`;
const plug08 = `${S3}/work/plug/08.jpg`;

// Work - Nescafé
const nescafe01 = `${S3}/work/nescafe/01.jpg`;
const nescafe02 = `${S3}/work/nescafe/02.jpg`;
const nescafe03 = `${S3}/work/nescafe/03.jpg`;
const nescafe04 = `${S3}/work/nescafe/04.jpg`;
const nescafe05 = `${S3}/work/nescafe/05.jpg`;
const nescafe06 = `${S3}/work/nescafe/06.jpg`;
const nescafe07 = `${S3}/work/nescafe/07.jpg`;
const nescafe08 = `${S3}/work/nescafe/08.jpg`;
const posterNescafe = `${S3}/work/nescafe/poster.jpg`;
const posterNescafeRos = `${S3}/work/nescafe/poster_ros.jpg`;
const posterBanana = `${S3}/work/banana/poster.jpg`;
const posterMezcal = `${S3}/work/mezcalbuenviaje/poster.jpg`;
const posterFiltros = `${S3}/work/filtros/poster.jpg`;
const posterChevrolet = `${S3}/work/chevrolet/poster.jpg`;
const posterHolcim = `${S3}/work/holcim/poster.jpg`;
const posterHolcimAR = `${S3}/work/holcim/poster_holcim.jpg`;
const posterAsepxia = `${S3}/work/asepxia/poster.jpg`;

// Work - Banana
const banana01 = `${S3}/work/banana/01.jpg`;

// Work - Creadores de Bicis
const bici01 = `${S3}/work/bicis/01.jpg`;
const bici02 = `${S3}/work/bicis/02.jpg`;
const bici03 = `${S3}/work/bicis/03.jpg`;
const bici04 = `${S3}/work/bicis/04.jpg`;
const bici05 = `${S3}/work/bicis/05.jpg`;
const bici06 = `${S3}/work/bicis/06.jpg`;
const bici07 = `${S3}/work/bicis/07.jpg`;
const bici08 = `${S3}/work/bicis/08.jpg`;

class Home extends React.Component {

  // ─── LIFECYCLE ──────────────────────────────────────────────────────────────

  constructor(props) {
    super(props);
    this.state = { raycastCursorPointer: "default" };
    this.modalVideo = React.createRef();
    this.workModal = React.createRef();
    this.finishSplash = this.finishSplash.bind(this);

    this.workItems = [
      {
        sections: [
          {
            title: "Artika Books — Museo Virtual",
            description: "Experiencia web inmersiva desarrollada para Artika Books, donde los usuarios exploran un museo virtual dedicado a las obras de Frida Kahlo y Fernando Botero. \n\nParticipamos en la conceptualización y bajada digital del proyecto, transformando la idea creativa en una experiencia navegable, interactiva y visualmente envolvente. El sitio fue desarrollado con Three.js, integrando entornos 3D, recorridos virtuales y una interfaz web diseñada para acercar el arte editorial a los usuarios de una forma innovadora y memorable.",
            images: [artika01, artika02, artika03, artika04, artika05, artika06, artika07, artika08],
            url: "https://artika.oclusion.net/"
          },
        ],
      },
      {
        sections: [
          {
            title: "Mercedes-Benz — Dealer Sales Platform",
            description: "Plataforma móvil para concesionarios que permite consultar el catálogo de vehículos Mercedes-Benz, explorar especificaciones, versiones, equipamiento y realizar comparativos con otras marcas premium para apoyar la toma de decisiones de los clientes.",
            images: [mercedes01, mercedes02, mercedes03, mercedes04, mercedes05, mercedes06, mercedes07, mercedes08, mercedes09, mercedes10]
          },
          {
            title: "YIM App",
            description: "Plataforma fitness diseñada para C++ Gimnasios que permite realizar entrenamientos en vivo o grabados, gestionar rutinas personalizadas y monitorear el progreso mediante métricas, historial de actividad y seguimiento de objetivos.",
            images: [yim01, yim02, yim03, yim04, yim05],
            portrait: true
          }
        ],
      },
      {
        sections: [
          {
            title: "Palacio de Hierro - Informe Anual 2020",
            description: "Desarrollo de un micrositio interactivo para el Informe Anual 2020, diseñado para comunicar los resultados, indicadores y estrategia de la compañía mediante una experiencia de navegación dinámica, contenido multimedia y visualizaciones animadas.",
            images: [palacio01, palacio02, palacio03, palacio04, palacio05, palacio06, palacio07, palacio08, palacio09, palacio10],
            url: "https://palacio.oclusion.net/"
          },
        ],
      },
      {
        sections: [
          {
            title: "",
            description: "Desarrollamos personajes 3D y props de alto impacto con arquitectura multiplataforma. Desde la concepción artística hasta la optimización técnica, creamos activos versátiles diseñados para coexistir en cualquier ecosistema multimedia: spots publicitarios, material gráfico impreso y entornos de Realidad Virtual (VR) y Aumentada (AR). Dotamos a tu marca de un activo visual consistente y escalable que cautiva a tu audiencia en cualquier punto de contacto.",
          },
          {
            title: "Chester Cheetos",
            description: "",
            images: [tresd01]
          },
          {
            title: "Chonchito",
            description: "",
            video: `${S3}/videos/CHONCHITO_FRESCO_SLIDE.mp4`,
            poster: posterChonchito,
          },
          {
            title: "Grisi",
            description: "",
            images: [tresd02]
          },
          {
            title: "Inspireka",
            description: "",
            images: [tresd03]
          },
        ],
      },
      {
        sections: [
          {
            title: "Nescafé Tributo",
            description: "Experiencia web interactiva desarrollada para Nescafé que combina visualización de datos, storytelling y WebGL. Los usuarios podían enviar mensajes de agradecimiento a caficultores mexicanos, representados como nodos que hacían crecer un árbol digital en tiempo real. El proyecto incluía navegación 3D, filtros dinámicos por tipo de publicación, género y horario, búsqueda de mensajes, contenido editorial y una experiencia inmersiva diseñada para fortalecer el vínculo entre la marca y su comunidad.",
            images: [nescafe01, nescafe02, nescafe03, nescafe04, nescafe05, nescafe06, nescafe07, nescafe08]
          },
          {
            title: "Nescafé",
            description: "",
            video: `${S3}/videos/nescafe_web.mp4`,
            poster: posterNescafe
          },
          {
            title: "Nescafé",
            description: "",
            video: `${S3}/videos/nescafe_ros_web.mp4`,
            poster: posterNescafeRos
          },
        ],
      },
      {
        sections: [
          {
            title: "Banana Boat",
            description: "Transformamos la divulgación científica en una experiencia sensorial inolvidable. Mediante técnicas avanzadas de videomapping 3D, creamos un entorno inmersivo que transporta al espectador al hábitat marino. Esta instalación narrativa no solo visualiza el impacto de los 'Nest Domes' de Banana Boat en el equilibrio de las tortugas, sino que sumerge al usuario en una vivencia única donde la tecnología se pone al servicio de la conservación.",
            video: `${S3}/videos/totugas_web.mp4`,
            poster: posterBanana
          },
          {
            title: "",
            description: "",
            images: [banana01],
            portrait: true
          },
        ],
      },
      {
        sections: [
          {
            title: "Nike — LunarEpic Flyknit Experience",
            description: "Instalación interactiva desarrollada para Nike que utilizaba Leap Motion para controlar una experiencia inmersiva mediante gestos de las manos. Los usuarios podían explorar el modelo LunarEpic Flyknit en 3D, descubrir sus tecnologías y acceder a contenido multimedia diseñado para exhibiciones y activaciones de marca.",
            video: `${S3}/videos/nike.mp4`,
            poster: posterNike
          },
        ],
      },
      {
        sections: [
          {
            title: "Doritos",
            description: "Experiencia teaser interactiva desarrollada para Doritos como parte de una campaña digital previa al lanzamiento del sitio principal. Construida con Three.js y WebGL, la experiencia combinaba gráficos 3D en tiempo real, animaciones y un minijuego inmersivo diseñado para generar expectativa y aumentar el engagement de la audiencia antes de la campaña oficial.",
            video: `${S3}/videos/doritos_web.mp4`,
            poster: posterDoritos
          },
          {
            title: "Plug & Plant",
            description: "Sitio web desarrollado para presentar el producto de Plug & Plant mediante un modelo 3D interactivo, permitiendo a los usuarios explorarlo desde distintos ángulos y conocer sus características a través de una experiencia visual inmersiva.",
            images: [plug01, plug02, plug03, plug04, plug05, plug06, plug07, plug08],
          },
          {
            title: "Creadores de Bicis",
            description: "Sitio web desarrollado para Creadores de Bicis que combina branding, catálogo de productos y experiencia interactiva. El proyecto integra storytelling visual, galerías dinámicas, personalización de bicicletas por modelo y color, mapas de distribuidores y una navegación enfocada en transmitir el estilo de vida urbano de la marca mediante una interfaz limpia y una experiencia de usuario fluida.",
            images: [bici01, bici02, bici03, bici04, bici05, bici06, bici07, bici08]
          },
          {
            title: "Fud Website - Wordpress",
            description: "Sitio web corporativo desarrollado para FUD sobre una plantilla de WordPress completamente personalizada, adaptada a las necesidades de contenido, diseño y administración del cliente. El proyecto incluyó la implementación de una interfaz a medida, optimización de la experiencia de usuario y un CMS flexible que permite la gestión y actualización del sitio de forma sencilla.",
            images: [fud01, fud02, fud03, fud04, fud05, fud06]
          },
          {
            title: "Asepxia",
            description: "Campaña digital para Asepxia, marca líder en cuidado de la piel. Desarrollamos la experiencia web y el modelo de machine learning para el reconocimiento facial y detección de imperfecciones. La aplicación analiza el rostro del usuario en tiempo real, identifica el tipo y nivel de acné, y recomienda el producto ideal de la línea Asepxia.",
            video: `${S3}/videos/asepxia.mp4`,
            poster: posterAsepxia
          },
        ],
      },
      {
        sections: [
          {
            title: "Mezcal Buen Viaje",
            description: "Sitio web desarrollado artesanalmente para Mezcal Buen Viaje, con una experiencia visual y narrativa enfocada en transmitir la esencia de la marca. El proyecto fue reconocido como Site of the Day en Awwwards y logró posicionarse orgánicamente durante su primer mes entre los primeros resultados de búsqueda para la palabra “mezcal”, gracias a una estrategia sólida de SEO, performance y contenido optimizado.",
            video: `${S3}/videos/mezcalbuenviaje_web.mp4`,
            poster: posterMezcal
          }
        ],
      },
      {
        sections: [
          {
            title: "Filtros",
            description: "Potenciamos la presencia digital de tu marca mediante la creación de experiencias de Realidad Aumentada (AR) 3D inmersivas. Diseñamos filtros interactivos diseñados estratégicamente para transformar a tus consumidores en creadores de contenido, impulsando el User-Generated Content (UGC) y maximizando la viralidad orgánica en Facebook, Instagram y TikTok.",
            video: `${S3}/videos/Filtros_1_opt.mp4`,
            poster: posterFiltros,
            portrait: true
          }
        ]
      },
      {
        sections: [
          {
            title: "Chevrolet Live",
            description: "Experiencia de showroom virtual en tiempo real para Chevrolet México. El usuario puede explorar el vehículo desde cualquier dispositivo mientras un asesor lo acompaña en videollamada, responde preguntas y navega el sitio de forma sincronizada. Desarrollamos la plataforma completa: streaming en vivo, chat integrado, galería interactiva del auto y agendado de prueba de manejo.",
            video: `${S3}/videos/chevrolet.mp4`,
            poster: posterChevrolet
          },
          {
            title: "",
            description: "Desarrollamos la aplicación móvil para el asesor de ventas: una interfaz optimizada para iPhone montado en un estabilizador gimbal, que transmitía video en vivo mientras navegaba el auto en el showroom. La comunicación entre la app del asesor y la pantalla del cliente se realizaba en tiempo real mediante WebSockets peer to peer, sincronizando navegación, galería y acciones de forma instantánea.",
            images: [chevrolet01],
            portrait: true,
          }
        ]
      },
      {
        sections: [
          {
            title: "Hold Fast - Shopify",
            description: "Diseñamos y desarrollamos el eCommerce de Hold Fast sobre Shopify, creando una experiencia de compra moderna, rápida y optimizada para dispositivos móviles. Personalizamos la tienda para reflejar la identidad de la marca, mejorando la navegación, la presentación de productos y el proceso de compra para ofrecer una experiencia fluida y enfocada en la conversión.",
            images: [ecommerce02],
            url: "https://holdfast.mx/"
          },
          {
            title: "Innes Strong - Shopify",
            description: "Creamos una tienda en línea sobre Shopify que combina diseño, estrategia y tecnología para ofrecer una experiencia de compra fluida. Desde la arquitectura de navegación hasta la personalización de la interfaz, cada detalle fue desarrollado para fortalecer la presencia digital de la marca y maximizar la conversión.",
            images: [ecommerce01],
            url: "https://www.innesstrong.com/"
          }
        ]
      },
      {
        sections: [
          {
            title: "Colgate - VR Experience",
            description: "Experiencia de realidad virtual diseñada para transformar la interacción con la marca, combinando contenido inmersivo, storytelling y tecnología VR.",
            video: `${S3}/videos/colgate.mp4`,
            poster: posterColgate,
          },
          {
            title: "Mobil - VR Experience",
            description: "Experiencia inmersiva de realidad virtual desarrollada para Mobil, diseñada para presentar productos y fortalecer la comunicación de la marca mediante entornos 3D interactivos y una experiencia envolvente.",
            video: `${S3}/videos/MOVIL.mp4`,
            poster: mobil07,
          },
          {
            title: "",
            description: "",
            images: [mobil01, mobil02, mobil03, mobil04, mobil05, mobil06, mobil07]
          }
        ]
      },
      {
        sections: [
          {
            title: "Holcim Postal",
            description: "Postal con realidad aumentada para Cemento Apasco de Holcim. Al escanear la postal física con la app, el catálogo de productos cobra vida en 3D sobre el papel: el usuario puede explorar cada línea de cemento, ver sus características y acceder a más información con solo tocar el producto. Una experiencia que conecta el mundo físico con el digital en el punto de venta.",
            video: `${S3}/videos/Apasco.mp4`,
            poster: posterHolcim,
          },
          {
            title: "Holcim Publicación",
            description: "Ciudad de construcción en realidad aumentada para Holcim México. Al escanear la postal, una maqueta 3D animada cobra vida sobre el papel: grúas, excavadoras y camiones se mueven en tiempo real mientras el usuario puede tocar cada zona para acceder a los distintos productos y soluciones de la marca. Una experiencia inmersiva que convierte un material impreso en un punto de contacto digital interactivo.",
            video: `${S3}/videos/Holcim.mp4`,
            poster: posterHolcimAR,
          }
        ]
      },
      {
        sections: [
          {
            title: "1800",
            description: "Sitio web para Tequila 1800, una de las marcas de tequila premium más reconocidas del mundo. Desarrollamos una experiencia digital oscura y elegante que refleja la identidad de la marca: fotografía cinematográfica en blanco y negro, navegación lateral inmersiva y una sección de productos interactiva donde el usuario puede explorar cada variedad — Blanco, Reposado, Añejo y Cristalino — con sus notas, historia y cócteles sugeridos.",
            images: [milocho01, milocho02, milocho03, milocho04, milocho05, milocho06, milocho07, milocho08, milocho09, milocho10, milocho11, milocho12],
            url: "https://1800.oclusion.net"
          }
        ]
      },
    ];
    this.mouseX = 0;
    this.mouseY = 0;
    this.onResize();
    this.initZVideoPlane = 2750 * 0.5;
  }

  componentDidMount() {
    gsap.registerPlugin(ScrollTrigger);
    this.registerParallaxElements();
    this.props.finishSplash(this.finishSplash);
    this.addListeners();
    this.initThree();
  }

  componentWillUnmount() {
    this.removeListeners();
    this.stop();
  }

  componentDidUpdate() {}

  finishSplash = () => {
    window.scrollTo(0, 0);
    document.body.style.overflow = '';
    this.props["hide-loader"](0.5, 1);
  }

  // ─── THREE.JS SETUP ─────────────────────────────────────────────────────────

  initThree = () => {
    const width = this.mount.clientWidth;
    const height = this.mount.clientHeight;

    this.scene = new THREE.Scene();

    // Luces para el cromo
    const ambientLight = new THREE.AmbientLight(0xffffff, 0.3);
    this.scene.add(ambientLight);
    const dirLight1 = new THREE.DirectionalLight(0xffffff, 1.5);
    dirLight1.position.set(5, 10, 5);
    this.scene.add(dirLight1);
    const dirLight2 = new THREE.DirectionalLight(0xCCCB00, 1.0);
    dirLight2.position.set(-5, -5, -5);
    this.scene.add(dirLight2);

    this.isMobileDevice = isMobile;
    this.renderer = new THREE.WebGLRenderer({ antialias: true, alpha: false, preserveDrawingBuffer: true });
    this.renderer.setPixelRatio(this.isMobileDevice ? 1 : (window.devicePixelRatio || 1));
    this.renderer.setSize(width, height);
    this.renderer.toneMapping = THREE.ACESFilmicToneMapping;
    this.renderer.toneMappingExposure = 0.5;
    this.mount.appendChild(this.renderer.domElement);

    const pmrem = new THREE.PMREMGenerator(this.renderer);
    pmrem.compileEquirectangularShader();
    new EXRLoader()
      .setPath(`${S3}/exr/`)
      .load("moonless_golf_1k.exr", (texture) => {
        this.scene.environment = pmrem.fromEquirectangular(texture).texture;
        texture.dispose();
        pmrem.dispose();
      });

    this.camera = new THREE.PerspectiveCamera(70, width / height, 1, 50000);
    this.camera.position.z = 2750;

    this.createVideoPlane();
    this.loadModel();
    this.createPlaneLogo();
    this.setupBloom(width, height);
    this.start();
  }

  // ─── BLOOM / POST-PROCESSING (desktop only) ─────────────────────────────────

  setupBloom = (width, height) => {
    this.BLOOM_LAYER = 1;
    this.bloomLayer = new THREE.Layers();
    this.bloomLayer.set(this.BLOOM_LAYER);

    if (this.isMobileDevice) return;

    const bloomPass = new UnrealBloomPass(new THREE.Vector2(width, height), 0.5, 0.4, 0.15);

    this.bloomComposer = new EffectComposer(this.renderer);
    this.bloomComposer.renderToScreen = false;
    this.bloomComposer.addPass(new RenderPass(this.scene, this.camera));
    this.bloomComposer.addPass(bloomPass);

    const finalPass = new ShaderPass(
      new THREE.ShaderMaterial({
        uniforms: {
          baseTexture: { value: null },
          bloomTexture: { value: this.bloomComposer.renderTarget2.texture }
        },
        vertexShader:   `varying vec2 vUv; void main() { vUv = uv; gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0); }`,
        fragmentShader: `uniform sampler2D baseTexture; uniform sampler2D bloomTexture; varying vec2 vUv; void main() { gl_FragColor = texture2D(baseTexture, vUv) + texture2D(bloomTexture, vUv); }`
      }),
      'baseTexture'
    );
    finalPass.needsSwap = true;

    this.finalComposer = new EffectComposer(this.renderer);
    this.finalComposer.addPass(new RenderPass(this.scene, this.camera));
    this.finalComposer.addPass(finalPass);
    this.finalComposer.addPass(new OutputPass());
  }

  darkenNonBloomed = () => {
    this.scene.traverse((obj) => {
      if (obj.isMesh && !this.bloomLayer.test(obj.layers)) obj.visible = false;
    });
  }

  restoreMaterials = () => {
    this.scene.traverse((obj) => {
      if (obj.isMesh && !this.bloomLayer.test(obj.layers)) obj.visible = true;
    });
  }

  // ─── OBJ MODEL ──────────────────────────────────────────────────────────────

  loadModel = () => {
    const loader = new OBJLoader();
    loader.load(`${S3}/obj/planta_05.obj`, this.objLoad);
  }

  objLoad = (obj) => {
    this.model = obj;
    this.model.visible = false;

    const vhWorld = 2 * Math.tan(THREE.MathUtils.degToRad(this.camera.fov / 2)) * this.camera.position.z;
    const box = new THREE.Box3().setFromObject(this.model);
    const center = box.getCenter(new THREE.Vector3());
    const size = box.getSize(new THREE.Vector3());

    const pageWorldHeight = vhWorld * (document.body.scrollHeight / window.innerHeight);
    const scale = (pageWorldHeight / size.y) * 0.8;
    this.model.scale.setScalar(scale);

    this.modelScrollStartY = vhWorld / 2 - box.max.y * scale;
    this.modelScrollEndY   = -vhWorld / 2 - box.min.y * scale;
    this.modelCenterOffsetY = center.y * scale;
    this.modelWorldHeight = size.y * scale;
    //this.createParticles(this.modelWorldHeight);
    this.createAscendingParticles();
    this.createRisingParticles();

    this.model.position.set(-center.x * scale, this.modelScrollStartY, -center.z * scale - 3500);

    this.modelMaterial = new THREE.MeshBasicMaterial({ color: 0xCCCB00, wireframe: true, depthWrite: false, transparent: true });
    this.model.traverse((child) => {
      if (child.isMesh) {
        child.material = this.modelMaterial;
        child.layers.enable(this.BLOOM_LAYER);
      }
    });

    this.scene.add(this.model);

    // Cargar GLB con los valores calculados del OBJ
    const glbLoader = new GLTFLoader();
    glbLoader.load(`${S3}/gltf/Planta.glb`, (gltf) => {
      this.modelGLB = gltf.scene;
      const boxGLB = new THREE.Box3().setFromObject(this.modelGLB);
      const sizeGLB = boxGLB.getSize(new THREE.Vector3());
      const scaleGLB = (pageWorldHeight / sizeGLB.y) * 0.6;
      const centerGLB = boxGLB.getCenter(new THREE.Vector3());

      this.modelScrollStartYGLB = vhWorld / 2 - (boxGLB.max.y * 4.4) * scaleGLB;
      this.modelScrollEndYGLB = -vhWorld / 2 - (boxGLB.min.y * -0.1) * scaleGLB;

      this.modelGLB.scale.setScalar(scaleGLB);
      this.modelGLB.position.set(-centerGLB.x * scaleGLB, this.modelScrollStartYGLB, -centerGLB.z * scaleGLB - 3500);

      // Material cromo
      const chromeMaterial = new THREE.MeshPhysicalMaterial({
        color: 0x888888,
        metalness: 1.0,
        roughness: 0.05,
        envMapIntensity: 1.0,
        reflectivity: 1.0,
        emissive: 0x000000,
        transparent: true,
      });
      this.modelMaterial = chromeMaterial;

      this.modelGLB.traverse((child) => {
        if (child.isMesh) {
          child.material = chromeMaterial;
          child.layers.enable(this.BLOOM_LAYER);
        }
      });
      this.scene.add(this.modelGLB);

      if (gltf.animations.length > 0) {
        this.clock = new THREE.Clock();
        this.mixer = new THREE.AnimationMixer(this.modelGLB);
        gltf.animations.forEach((clip) => this.mixer.clipAction(clip).play());
      }
    });
  }

  // ─── VIDEO PLANE ────────────────────────────────────────────────────────────

  createVideoPlane = () => {
    const video = document.createElement("video");
    video.crossOrigin = "anonymous";
    video.src = `${S3}/videos/passionate.mp4`;
    video.loop = true;
    video.muted = true;
    video.playsInline = true;
    video.setAttribute("playsinline", "");
    video.setAttribute("webkit-playsinline", "");
    video.play();

    const videoTexture = new THREE.VideoTexture(video);
    videoTexture.minFilter = THREE.LinearFilter;
    videoTexture.magFilter = THREE.LinearFilter;
    videoTexture.generateMipmaps = false;

    const h = 2 * Math.tan((this.camera.fov * Math.PI) / 360) * this.initZVideoPlane;
    const w = h * (960 / 540);

    const geometry = new THREE.PlaneGeometry(w, h, 10, 6);
    const material = new THREE.MeshBasicMaterial({ map: videoTexture, transparent: true, opacity: this.isMobileDevice ? 0.7 : 1.0 });
    this.plane = new THREE.Mesh(geometry, material);
    this.plane.position.z = this.initZVideoPlane;
    this.scene.add(this.plane);
  }

  moveVideoPlane = () => {
    if (!this.plane) return;
    const scrollMax = (document.body.scrollHeight - window.innerHeight) / 5;
    const scrollRatio = Math.min(window.scrollY / scrollMax, 1);

    this.plane.position.z = this.initZVideoPlane + scrollRatio * (-this.initZVideoPlane - this.initZVideoPlane);
    this.plane.rotation.x = Math.max(0, (scrollRatio - 0.7) / 0.3) * -Math.PI / 2;
    const baseOpacity = this.isMobileDevice ? 0.7 : 1.0;
    this.plane.material.opacity = baseOpacity * (1 - Math.max(0, (scrollRatio - 0.6) / 0.4));
  }

  // ─── LOGO PLANE ─────────────────────────────────────────────────────────────

  createPlaneLogo = () => {
    const geometry = new THREE.PlaneGeometry(400, 400, 4, 4);
    const loaderTexture = new THREE.TextureLoader();
    const material = new THREE.MeshBasicMaterial({ map: loaderTexture.load(`${S3}/logos/logo-final.png`), transparent: true, opacity: 0 });
    this.planeLogo = new THREE.Mesh(geometry, material);
    this.planeLogo.position.z = -(this.initZVideoPlane * 2);
    this.scene.add(this.planeLogo);
  }

  // ─── PARTICLES ──────────────────────────────────────────────────────────────

  createParticles = (modelHeight) => {
    const count = 250;
    const positions = new Float32Array(count * 3);

    for (let i = 0; i < count; i++) {
      positions[i * 3]     = (Math.random() - 0.5) * 8000;
      positions[i * 3 + 1] = (Math.random() - 0.15) * modelHeight * 1.4;
      positions[i * 3 + 2] = (Math.random() - 0.5) * 6000;
    }

    const geometry = new THREE.BufferGeometry();
    geometry.setAttribute('position', new THREE.BufferAttribute(positions, 3));

    const material = new THREE.PointsMaterial({
      color: 0xCCCB00,
      size: 18,
      transparent: true,
      opacity: 0.8,
      depthWrite: false,
      sizeAttenuation: true,
    });

    this.particles = new THREE.Points(geometry, material);
    this.particles.layers.enable(this.BLOOM_LAYER);
    // Inicializar posición Y directamente para evitar lerp inicial
    this.particles.position.y = this.modelScrollStartY + modelHeight * 0.5;
    this.particles.position.z = -3500;
    this.scene.add(this.particles);
    this.particlesTime = 0;
  }

  createAscendingParticles = () => {
    const count = 400;
    const positions = new Float32Array(count * 3);
    this.ascSpeeds   = new Float32Array(count);
    this.ascAngles   = new Float32Array(count);
    this.ascRadii    = new Float32Array(count);
    this.ascAngSpeeds = new Float32Array(count);
    const yMin = -4000;
    const yMax =  4000;

    for (let i = 0; i < count; i++) {
      const angle  = Math.random() * Math.PI * 2;
      const radius = 900 + Math.random() * 5400;
      this.ascAngles[i]    = angle;
      this.ascRadii[i]     = radius;
      this.ascSpeeds[i]    = 2 + Math.random() * 3.5;
      this.ascAngSpeeds[i] = (0.0005 + Math.random() * 0.002) * (Math.random() < 0.5 ? 1 : -1);

      positions[i * 3]     = Math.cos(angle) * radius;
      positions[i * 3 + 1] = yMin + Math.random() * (yMax - yMin);
      positions[i * 3 + 2] = Math.sin(angle) * radius - 3500;
    }

    const geometry = new THREE.BufferGeometry();
    geometry.setAttribute('position', new THREE.BufferAttribute(positions, 3));

    const material = new THREE.PointsMaterial({
      color: 0xCCCB00,
      size: this.isMobileDevice ? 16 : 12,
      transparent: true,
      opacity: 0.4,
      depthWrite: false,
      sizeAttenuation: true,
    });

    this.ascParticles = new THREE.Points(geometry, material);
    this.ascParticles.layers.enable(this.BLOOM_LAYER);
    this.scene.add(this.ascParticles);
  }

  updateAscendingParticles = () => {
    if (!this.ascParticles) return;
    const positions = this.ascParticles.geometry.attributes.position.array;
    const yMax = 4000;
    const yMin = -4000;

    const target = this.modelGLB || this.model;
    const cx = target ? target.position.x : 0;
    const cz = target ? target.position.z : -3500;

    for (let i = 0; i < this.ascSpeeds.length; i++) {
      this.ascAngles[i] += this.ascAngSpeeds[i];
      positions[i * 3]     = cx + Math.cos(this.ascAngles[i]) * this.ascRadii[i];
      positions[i * 3 + 1] += this.ascSpeeds[i];
      positions[i * 3 + 2] = cz + Math.sin(this.ascAngles[i]) * this.ascRadii[i];

      if (positions[i * 3 + 1] > yMax) {
        positions[i * 3 + 1] = yMin;
      }
    }
    this.ascParticles.geometry.attributes.position.needsUpdate = true;
  }

  createRisingParticles = () => {
    const count = 200;
    const positions = new Float32Array(count * 3);
    this.riseSpeed = new Float32Array(count);
    const spread = 6000;
    const yMin = -4000;
    const yMax =  4000;

    for (let i = 0; i < count; i++) {
      positions[i * 3]     = (Math.random() - 0.5) * spread;
      positions[i * 3 + 1] = yMin + Math.random() * (yMax - yMin);
      positions[i * 3 + 2] = (Math.random() - 0.5) * spread - 3500;
      this.riseSpeed[i] = 1.5 + Math.random() * 3;
    }

    const geometry = new THREE.BufferGeometry();
    geometry.setAttribute('position', new THREE.BufferAttribute(positions, 3));

    const material = new THREE.PointsMaterial({
      color: 0xCCCB00,
      size: this.isMobileDevice ? 14 : 10,
      transparent: true,
      opacity: 0.3,
      depthWrite: false,
      sizeAttenuation: true,
    });

    this.riseParticles = new THREE.Points(geometry, material);
    this.riseParticles.layers.enable(this.BLOOM_LAYER);
    this.scene.add(this.riseParticles);
  }

  updateRisingParticles = () => {
    if (!this.riseParticles) return;
    const positions = this.riseParticles.geometry.attributes.position.array;
    const yMax = 4000;
    const yMin = -4000;

    for (let i = 0; i < this.riseSpeed.length; i++) {
      positions[i * 3 + 1] += this.riseSpeed[i];
      if (positions[i * 3 + 1] > yMax) {
        positions[i * 3 + 1] = yMin;
      }
    }
    this.riseParticles.geometry.attributes.position.needsUpdate = true;
  }

  updateParticles = () => {
    if (!this.particles) return;
    const target = this.modelGLB || this.model;
    this.particlesTime += 0.001;
    this.particles.rotation.y = this.particlesTime * 0.2;
    if (target) {
      const targetY = target.position.y + (this.modelWorldHeight || 0) * 0.5;
      this.particles.position.y += (targetY - this.particles.position.y) * 0.05;
      this.particles.position.z = target.position.z;
    }
  }

  movePlaneLogo = () => {
    if (!this.planeLogo) return;
    const totalScroll = document.body.scrollHeight - window.innerHeight;
    const offset = totalScroll * 0.9;
    const scrollMax = totalScroll - offset;
    const scrollRatio = Math.min(Math.max(0, (window.scrollY - offset) / scrollMax), 1);

    this.planeLogo.position.z = -(this.initZVideoPlane * 2) + scrollRatio * (this.initZVideoPlane * 3);
    this.planeLogo.material.opacity = scrollRatio;
  }

  // ─── SCROLL ─────────────────────────────────────────────────────────────────

  onScroll = () => {
    this.moveModelGLTF();
    this.moveVideoPlane();
    this.movePlaneLogo();
  }

  moveModelGLTF = () => {
    if (this.modelScrollStartY === undefined && this.modelScrollStartYGLB === undefined) return;
    const maxScroll = document.body.scrollHeight - window.innerHeight;
    if (maxScroll <= 0) return;
    const t = window.scrollY / maxScroll;

    const posY = this.modelScrollStartY + t * (this.modelScrollEndY - this.modelScrollStartY);
    const posYGLB = this.modelScrollStartYGLB + t * (this.modelScrollEndYGLB - this.modelScrollStartYGLB);
    const rotY = t * Math.PI * 0.4;
    const rotX = t * Math.PI * 0.1;

    if (this.model) {
      this.model.position.y = posY;
      this.model.rotation.y = rotY;
      this.model.rotation.x = rotX;
    }
    if (this.modelGLB) {
      this.modelGLB.position.y = posYGLB;
      this.modelGLB.rotation.y = rotY;
      this.modelGLB.rotation.x = rotX;
    }

    const tFade = Math.max(0, (t - 0.8) / 0.2);
    if (this.modelMaterial) this.modelMaterial.opacity = 1 - tFade * 0.9;
  }

  // ─── RENDER LOOP ────────────────────────────────────────────────────────────

  start = () => {
    if (!this.frameId) this.frameId = requestAnimationFrame(this.animate);
  }

  stop = () => {
    cancelAnimationFrame(this.frameId);
  }

  animate = () => {
    this.renderScene();
    this.frameId = window.requestAnimationFrame(this.animate);
  }

  renderScene = () => {
    if (this.mixer && this.clock) this.mixer.update(this.clock.getDelta() * 0.5);
    this.updateParticles();
    this.updateAscendingParticles();
    this.updateRisingParticles();
    this.camera.position.x += (this.mouseX - this.camera.position.x) * .05;
    this.camera.position.y += (-this.mouseY - this.camera.position.y) * .05;
    this.camera.lookAt(this.scene.position);
    if (this.isMobileDevice) {
      this.renderer.render(this.scene, this.camera);
    } else {
      this.darkenNonBloomed();
      this.bloomComposer.render();
      this.restoreMaterials();
      this.finalComposer.render();
    }
  }

  // ─── EVENTS / RESIZE ────────────────────────────────────────────────────────

  addListeners = () => {
    window.addEventListener("resize", this.onResize);
    window.addEventListener("scroll", this.onScroll);
  }

  removeListeners = () => {
    window.removeEventListener("resize", this.onResize);
    window.removeEventListener("scroll", this.onScroll);
  }

  onResize = () => {
    this.w = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    this.h = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
    this.windowHalfX = this.w / 2;
    this.windowHalfY = this.h / 2;
    if (this.renderer) {
      this.camera.aspect = this.w / this.h;
      this.camera.updateProjectionMatrix();
      this.renderer.setSize(this.w, this.h);
      if (this.bloomComposer) this.bloomComposer.setSize(this.w, this.h);
      if (this.finalComposer) this.finalComposer.setSize(this.w, this.h);
    }
  }

  // ─── GSAP PARALLAX ──────────────────────────────────────────────────────────

  registerParallaxElements = () => {
    gsap.fromTo(".about-btn",
      { scale: 0.85, opacity: 0, y: 50 },
      {
        scrollTrigger: {
          trigger: ".about-btn",
          start: "0px 80%",
          end: "0px 50%",
          scrub: true,
        },
        scale: 1,
        opacity: this.isMobileDevice ? 1 : 1,
        y: 0,
        ease: "none",
        duration: 0.5
      }
    );
  }

  // ─── MODAL VIDEO ────────────────────────────────────────────────────────────

  openWorkModal = (index) => {
    this.workModal.current.open(index);
  }

  // ─── RENDER ─────────────────────────────────────────────────────────────────

  static tagline = "Impulsamos a las marcas con experiencias digitales que combinan creatividad, estrategia y tecnología. Colaboramos estrechamente con nuestros clientes para explorar ideas, proponer soluciones y construir productos digitales que generen un impacto real.";

  render() {
    return (
      <>
        {/* Canvas */}
        <div
          className="container-canvas"
          style={{ cursor: this.state.raycastCursorPointer, backgroundColor: "#ffffff" }}
          ref={(mount) => { this.mount = mount; }}
        />

        {/* Home */}
        <section className="container-section-home">
          <div className="left-column bg-green-color">
            <img className="left-column-logo" src={logow} />
          </div>
          <div className="content-home">
            <div className="content-home-first">
              <h2>digital.<span className="green-color">garden</span>.mx</h2>
            </div>
            <div className="content-home-second">
              <div className="first hide-mobile">
                <div className="one">
                  <img width={40} height="auto" src={logo} />
                </div>
                <div className="two">
                  <p>{Home.tagline}</p>
                </div>
              </div>
              <div className="second">
                <h1>Transformamos ideas en experiencias digitales<span className="terminal-cursor">_</span></h1>
              </div>
            </div>
          </div>
        </section>

        {/* Home info — solo mobile */}
        <div className="container-home-info-mobile">
          <div className="two">
            <p>{Home.tagline}</p>
          </div>
        </div>

        {/* About */}
        <section className="container-section-about">
          <div className="left-column"></div>
          <div className="content-about">
            <div className="content-about-first">
              <h1>
                <span>01.</span>
                <span>Acerca</span>
                <span className="work-p">En Digital Garden creemos que la tecnología es una herramienta para crear experiencias que inspiran, conectan y generan impacto. Diseñamos y desarrollamos aplicaciones, plataformas web, eCommerce, experiencias inmersivas y soluciones digitales que ayudan a las marcas a evolucionar y diferenciarse.</span>
                <span className="work-p">Como estudio de Creative Tech y producción digital, nos integramos al proceso creativo de agencias y marcas para explorar ideas desde el inicio. Aportamos nuestra experiencia técnica para proponer nuevas posibilidades, validar conceptos y construir productos digitales que convierten las mejores ideas en experiencias reales.</span>
              </h1>
              <div className="about-equation">
                <div className="about-equation-item">
                  <span className="about-equation-label">Creatividad</span>
                  <span className="about-equation-sub">Agencia / Marca</span>
                </div>
                <span className="about-equation-op">+</span>
                <div className="about-equation-item">
                  <span className="about-equation-label">Tecnología</span>
                  <span className="about-equation-sub">Digital Garden</span>
                </div>
                <span className="about-equation-op">=</span>
                <div className="about-equation-item">
                  <span className="about-equation-label green-color">Creative Tech</span>
                  <span className="about-equation-sub">Resultado</span>
                </div>
              </div>
            </div>
            <div className="content-about-second">
              <PixelateHover src={aboutPlaceholder} className="about-btn" />
            </div>
          </div>
        </section>

        {/* Work */}
        <section className="container-section-work">
          <div className="left-column"></div>
          <div className="content-work">
            <div className="content-work-first">
              <h1>
                <span>02.</span>
                <span>Nuestro trabajo</span>
                <span className="work-p">Creamos productos digitales que combinan estrategia, diseño, tecnología e inteligencia artificial.</span>
              </h1>
              <ul className="work-services">
                <li>UX / UI</li>
                <li>Sitios web</li>
                <li>Apps móviles</li>
                <li>eCommerce</li>
                <li>Inteligencia artificial</li>
                <li>3D</li>
                <li>Video</li>
                <li>Realidad aumentada</li>
                <li>Realidad virtual</li>
                <li>Data visualization</li>
                <li>SEO</li>
                <li>Email marketing</li>
              </ul>
            </div>
            <div className="content-work-second">
              <div className="div1 work-item" onClick={() => this.openWorkModal(0)}><img src={uno} /></div>
              <div className="div2 work-item" onClick={() => this.openWorkModal(1)}><img src={dos} /><div className="work-item-logo"><img src={logoMercedes} /></div></div>
              <div className="div3 work-item" onClick={() => this.openWorkModal(2)}><img src={tres} /></div>
              <div className="div4 work-item" onClick={() => this.openWorkModal(3)}><img src={cuatro} /></div>
              <div className="div5 work-item" onClick={() => this.openWorkModal(4)}><img src={cinco} /><div className="work-item-logo"><img src={logoNescafe} /></div></div>
              <div className="div6"></div>
              <div className="div7 work-item" onClick={() => this.openWorkModal(5)}><img src={siete} /></div>
              <div className="div8 work-item" onClick={() => this.openWorkModal(6)}><img src={ocho} /></div>
              <div className="div9 work-item" onClick={() => this.openWorkModal(7)}><img src={nueve} /></div>
              <div className="div10"></div>
              <div className="div11 work-item" onClick={() => this.openWorkModal(8)}><img src={mezcalbuenviaje} /></div>
              <div className="div12"></div>
              <div className="div13 work-item" onClick={() => this.openWorkModal(10)}><img src={seis} /><div className="work-item-logo"><img src={logoChevrolet} /></div></div>
              <div className="div14 work-item" onClick={() => this.openWorkModal(9)}><img src={catorce} /></div>
              <div className="div15 work-item" onClick={() => this.openWorkModal(11)}><img src={ecommerce02} /></div>
              <div className="div16 work-item" onClick={() => this.openWorkModal(12)}><img src={dieciseis} /><div className="work-item-logo"><img src={logoColgate} /></div></div>
              <div className="div17 work-item" onClick={() => this.openWorkModal(13)}><img src={holcim} /><div className="work-item-logo"><img src={logoHolcim} /></div></div>
              <div className="div18 work-item" onClick={() => this.openWorkModal(14)}><img src={dieciocho} /><div className="work-item-logo"><img src={logoMilOcho} /></div></div>
            </div>
          </div>
        </section>

        {/* Quote */}
        <div className="container-section-quote1">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <h2>
                  Tecnología que<br />
                  <span className="white-color">inspira</span><br />
                  y experiencias que<br />
                  conectan.
                </h2>
              </div>
            </div>
            <div className="row">
              <div className="col-12 text-right quote-icon">
                <img src={quote} />
              </div>
            </div>
          </div>
        </div>

        {/* Partners */}
        <section className="container-section-partners">
          <Partners />
          <p className="partners-tagline">Marcas que confían en nosotros.</p>
        </section>

        {/* Contact */}
        <section className="container-section-contact">
          <Contact />
        </section>

        <section className="container-section-about container-section-spacer" />

        <ModalVideo ref={this.modalVideo} close-completion={() => {}} />
        <WorkModal ref={this.workModal} items={this.workItems} />
      </>
    );
  }
}

export default function (props) {
  const navigation = useNavigate();
  return <Home {...props} navigation={navigation} />;
}
